import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import React from 'react'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Text from 'core/elements/Text'
import Tooltip from 'core/elements/tooltip'
import Theme from 'core/themes/model'

const useStyles = makeStyles<Theme>((theme) => ({
  bulkVMResults: {
    display: 'grid',
    gap: 8,
    gridAutoRows: 'max-content',
  },
  bulkVMResultsTitle: {
    marginBottom: 8,
  },
  bulkVMResultItem: {
    display: 'grid',
    gridTemplateColumns: '12px 200px max-content',
    gap: 16,
    alignItems: 'start',
  },
  failedIcon: {
    color: theme.components.badge.error.color,
    marginRight: 8,
  },
  successIcon: {
    color: theme.components.badge.success.color,
    marginRight: 8,
  },
}))

export interface ActionStateResult {
  id?: string
  name: string | React.ReactNode
  status: 'Success' | 'Failed' | 'In Progress' | ''
  error?: string
  actionName?: string
}

interface ShowActionStateProps {
  title?: string
  results: Array<ActionStateResult>
  error?: string
  customClassName?: string
}

const ShowActionState = ({ title, results, customClassName }: ShowActionStateProps) => {
  const classes = useStyles({})
  return (
    <div className={classes.bulkVMResults}>
      {title && (
        <Text variant="subtitle2" className={classes.bulkVMResultsTitle}>
          {title}
        </Text>
      )}
      {results.map(({ name, status, error, actionName }, index) => {
        const actionInProgress = status === 'In Progress'
        const actionFailed = status === 'Failed'
        const className = actionFailed ? classes.failedIcon : classes.successIcon

        return (
          <div key={index} className={clsx(customClassName, classes.bulkVMResultItem)}>
            <Text variant="body2">{index + 1}.</Text>
            <Text variant="body2">{name}</Text>
            {status && (
              <Tooltip message={actionFailed && error ? error : ''}>
                <Text variant="body2">
                  <FontAwesomeIcon className={className} spin={actionInProgress}>
                    {actionInProgress
                      ? 'rotate'
                      : actionFailed
                        ? 'circle-exclamation'
                        : 'circle-check'}
                  </FontAwesomeIcon>
                  {actionName ? actionName : status}
                </Text>
              </Tooltip>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default ShowActionState
